import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IEmployeesParams, IEmployeesResponse, IEmployeesState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchListEmployees = createAsyncThunk(
  'listEmployees/fetchListEmployees',
  async ({ query }: IEmployeesParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.employees(query)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IEmployeesState = {
  isLoading: false,
  response: null,
  error: null
}

const listEmployeesSlice = createSlice({
  name: 'employees/list',
  initialState,
  reducers: {
    resetListEmployees: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchListEmployees.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchListEmployees.fulfilled, (state, action: PayloadAction<IEmployeesResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchListEmployees.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default listEmployeesSlice.reducer
export const { resetListEmployees } = listEmployeesSlice.actions
